/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type PdpSharedProtectionOrLoyalty_user = {|
  +isVerifiedTrade: ?boolean;
  +tradeFirm: ?{|
    +loyalty: ?{|
      +isBlacklisted: ?boolean;
    |};
  |};
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedProtectionOrLoyalty_user",
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "isVerifiedTrade",
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbTradeLoyalty_user",
      "args": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "TradeFirmType",
      "name": "tradeFirm",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "TradeFirmLoyaltyType",
          "name": "loyalty",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "isBlacklisted",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User"
};

module.exports = fragment;
